import styled from '@nobia/zeus-components/lib/styled'
import React from 'react'

import { AccountProvider } from '../components/AccountContext'
import { CampaignProvider } from '../components/campaign'
import { CloudinaryProvider } from '../components/cloudinary/CloudinaryProvider'
import { SignalRProvider } from '../components/signalr-provider/SignalRProvider'
import { UserProvider } from '../components/user-provider/UserProvider'
import { Routes } from '../routes'
import GlobalStyles from '../styles/global'
import { useSharedStateSaver } from './sharedStateSaver'
import { ToastContainer } from 'react-toastify'

const Wrapper = styled.div``

const App = () => {
  useSharedStateSaver()

  return (
    <Wrapper>
    <ToastContainer
      position="top-right"
      autoClose={3000}
      theme="colored"
    />
      <CloudinaryProvider>
        <AccountProvider>
          <UserProvider>
            <SignalRProvider>
              <CampaignProvider>
                <GlobalStyles />
                <Routes />
              </CampaignProvider>
            </SignalRProvider>
          </UserProvider>
        </AccountProvider>
      </CloudinaryProvider>
    </Wrapper>
  )
}

export default App
